/*
*
    The entire extension was initially copied over from HCC extension.
*
*/
import Vue from 'vue';
import Vuelidate from 'vuelidate';
import { extensionS1Mixin } from '../mixins/index';
import { required } from 'vuelidate/lib/validators';
import datePicker from '../../../components/forms/component.date-picker.vue';
import { MainVueOpts } from '../../../main-vue';
import { ibSpinOpts } from '../../../helper-functions/applicationCommonValues';
import { createExtensionService } from '../../../helper-functions/services';
import { onlyAlphaNumeric, monthDate, numbersWithDashSlash, noAlphabets } from '../../../helper-functions/helper-functions';

Vue.use(Vuelidate);

export default {
    mixins:[MainVueOpts, extensionS1Mixin],
    components:{
        'date-picker': datePicker
    },
    data () {
        return {
            isInternalIP: window.globalLanguage.internalIP,
        }
    },
    validations: function() {
        const validations = {
            form:{
                certificateNumber: {
                    required,
                    onlyAlphaNumeric
                },
                birthDate: {
                    required,
                    monthDate,
                    numbersWithDashSlash,
                    noAlphabets
                }
            }
        };

        return validations;
    },
    mounted() {
        if (ibJS.extensionErrors) {
            this.$emit('backenderrors', ibJS.extensionErrors);
        }
    },
    methods: {
        submitForm: function (e) {
            if(e) e.preventDefault();

            this.$v.$touch();

            if (this.captchaIsIncomplete()) return;

            if (!this.$v.$invalid) {
                let spinTarget=this.$refs.btnspinner;
                let spinner = new IBSpinner(ibSpinOpts).spin(spinTarget);
                this.formSending = true;
                let urlLang = '/az-extension/';
                switch(window.globalLanguage.lang) {
                    case'es' :
                        urlLang = '/az-prorroga/';
                        break;
                    case'zh' :
                        urlLang = '/az-xubao/';
                        break;
                }
                let url = '/api'+urlLang;
                let data = JSON.stringify(this.form);
                this.resetCaptcha();
                createExtensionService.call(this, url, data, 'extension');

            } else {
                this.showMobileError = true;
            }
        },
        showResetApplicationModal() {
            this.resetForm('azimuth-extension');
        }
    }
};
